export default "__VITE_ASSET__DoXcnfx6__"